export const ageGroupFromDob = (dob) => {
  const m = /^(\d{4})-\d{2}-\d{2}/.exec(dob || "");
  if (!m) return "";
  const n = Math.min(Math.max(new Date().getFullYear() - Number(m[1]), 6), 19);
  return `U${n}`;
};
